import React from 'react';
import { Box, Modal, Text, Title } from '@mantine/core';
import { DayjsFormat, formatDateWithDay } from '@/helpers';
import DashboardButton from '@/pages/Event.page/DashboardButton';

import { EventViewProps } from '@/pages/Event.page/types';

export const EventHeading: React.FC<EventViewProps> = ({ eventStartTime, title, children }) => {
  const eventTitle = title || `Event Details`;

  return (
    <Modal.Content>
      <Modal.Header>
        <Box>
          <Title tt="capitalize" order={2}>
            {eventTitle}
          </Title>
          <Text c="dimmed">{formatDateWithDay(eventStartTime, DayjsFormat.LONG_DATE)}</Text>
        </Box>
        <Modal.CloseButton />
      </Modal.Header>
      <Modal.Body>
        {children}
        <DashboardButton />
      </Modal.Body>
    </Modal.Content>
  );
};
